import { TanstackDatabaseCollections } from "@/domains/tanstack-db/core/collections";

export interface StatsRepositoryDeps {
  collections: TanstackDatabaseCollections;
}

export class StatsRepository {
  private readonly collections: TanstackDatabaseCollections;

  constructor({ collections }: StatsRepositoryDeps) {
    this.collections = collections;
  }

  /**
   * Including this for backwards-compatibility with the old impl.
   */
  async getTotalSizeBytes(): Promise<number> {
    const encoder = typeof TextEncoder !== "undefined" ? new TextEncoder() : null;

    const sizeForCollection = <T extends object>(iterable: Iterable<[string | number, T]>) => {
      let total = 0;

      for (const [, value] of iterable) {
        try {
          const json = JSON.stringify(value) ?? "";
          if (encoder) {
            total += encoder.encode(json).length;
          } else if (typeof Buffer !== "undefined") {
            total += Buffer.byteLength(json, "utf8");
          } else {
            total += json.length;
          }
        } catch {
          // Ignore serialization issues and treat as zero bytes
        }
      }
      return total;
    };

    const contextsSize = sizeForCollection(this.collections.smartContexts.entries());
    const viewsSize = sizeForCollection(this.collections.smartViews.entries());
    const cardsSize = sizeForCollection(this.collections.smartCards.entries());

    return contextsSize + viewsSize + cardsSize;
  }

  async getPublicTableNames(): Promise<string[]> {
    return ["smart_contexts", "smart_views", "smart_cards"];
  }

  async getRowCountsByTable(): Promise<Array<{ table: string; rowCount: number }>> {
    return [
      { table: "smart_contexts", rowCount: this.collections.smartContexts.size },
      { table: "smart_views", rowCount: this.collections.smartViews.size },
      { table: "smart_cards", rowCount: this.collections.smartCards.size },
    ];
  }
}
